import React from "react";
import { Link } from "react-router-dom";
import { compose } from "helper/compose";
import { withTranslation, type WithTranslation } from "react-i18next";

import LoginForm from "./LoginForm";
import { withAuthData, type AuthInjectedProps } from "../context/AuthContext";

const LoginFormAny = LoginForm as unknown as React.ComponentType<Record<string, unknown>>;

interface FormErrorItem {
  code: string;
  message: string;
}

interface LoginPageOwnProps extends WithTranslation {}

type LoginPageProps = LoginPageOwnProps & AuthInjectedProps;

function LoginPage({ t, actions, loginPageMessage }: LoginPageProps) {
  const [formData, setFormData] = React.useState<{ email: string; password: string }>({
    email: "",
    password: "",
  });
  const [formError, setFormError] = React.useState<FormErrorItem[] | undefined>(undefined);
  const [isAuthenticating, setIsAuthenticating] = React.useState(false);

  const onFormChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const field = event.target.name as "email" | "password";
    const value = event.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const onFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    actions.removeLoginMessage();

    const errors: FormErrorItem[] = [];
    if (formData.email === "") {
      errors.push({ code: "MAIL", message: t("login.info_mail") });
    }
    if (formData.password === "") {
      errors.push({ code: "PASSWORD", message: t("login.info_password") });
    }

    setFormError(errors);

    if (errors.length === 0 && !isAuthenticating) {
      setIsAuthenticating(true);
      void actions
        .logInUser({
          username: formData.email,
          password: formData.password,
        })
        .finally(() => setIsAuthenticating(false));
    }
  };

  return (
    <div className="Page AuthPage LoginPageShell">
      <div className="Page-content AuthPage-content">
        <div className="AuthPage-header">
          <div className="LogoCompanyWrapper">
            <Link to={BASE_PATH + "/"}>
              <div className="LogoCompany isSpaced isGMC"></div>
            </Link>
          </div>
          <p className="AuthPage-kicker">{t("topbar.platform_label")}</p>
          <h2 className="Page-title isSpaced">{t("login.connect")}</h2>
        </div>
        <LoginFormAny
          onChange={onFormChange}
          onSubmit={onFormSubmit}
          formError={formError}
          message={loginPageMessage}
          isAuthenticating={isAuthenticating}
        />
      </div>
    </div>
  );
}

export default compose(withTranslation(), withAuthData)(LoginPage);
